import css from '@styled-system/css';
import styled from '@emotion/styled';
import BaseCard from '@bit/medicalwebexperts.mwe-ui.card';

const Card = styled(BaseCard.Body)(({ p = [8, 10] }) => css({ p }));

export default Card;
